<template>
<div>
	<b-card>
		<h5>Mes demandes</h5>
		<vue-good-table
		  :columns="columns"
		  :rows="ResultDemande"
		  :pagination-options="{
			enabled: true,
			perPage:pageLength
		  }"
		>
		  <template
			slot="table-row"
			slot-scope="props"
		  >
			<span
			  v-if="props.column.field === 'C_type'"
			  class="text-nowrap"
			>
			  <span>{{ props.row.C_type }} </span>
			</span>
			<span v-else>
			  {{ props.formattedRow[props.column.field] }}
			</span>
		  </template>

		  <!-- pagination -->
		  <template
			slot="pagination-bottom"
			slot-scope="props"
		  >
			<div class="d-flex justify-content-between flex-wrap">
			  <div class="d-flex align-items-center mb-0 mt-1">
				<span class="text-nowrap">
				  Ligne 1 à
				</span>
				<b-form-select
				  v-model="pageLength"
				  :options="['5','10','50','100']"
				  class="mx-1"
				  @input="(value)=>props.perPageChanged({currentPerPage:value})"
				/>
				<span class="text-nowrap"> sur {{ props.total }} lignes </span>
			  </div>
			  <div>
				<b-pagination
				  :value="1"
				  :total-rows="props.total"
				  :per-page="pageLength"
				  first-number
				  last-number
				  align="right"
				  prev-class="prev-item"
				  next-class="next-item"
				  class="mt-1 mb-0"
				  @input="(value)=>props.pageChanged({currentPage:value})"
				>
				  <template #prev-text>
					<feather-icon
					  icon="ChevronLeftIcon"
					  size="18"
					/>
				  </template>
				  <template #next-text>
					<feather-icon
					  icon="ChevronRightIcon"
					  size="18"
					/>
				  </template>
				</b-pagination>
			  </div>
			</div>
		  </template>
		</vue-good-table>
	</b-card>
</div>
</template>

<script>
import {
  BCard, BPagination, BFormSelect,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
	
export default {
	components: {
		BCard,
		BPagination,
		BFormSelect,
		VueGoodTable,
	},
	props: {
		ResultDemande: {},
	},
	data() {
		return {
			pageLength: 5,
			columns: [
				{
				  label: 'Type',
				  field: 'C_type',
				},
				{
				  label: 'Date',
				  field: 'Ddate',
				},
				{
				  label: 'Etat',
				  field: 'C_etat',
				},
			],
			selctrow: [],
		}
	},
	created() {
		// this.userData = JSON.parse(localStorage.getItem('userData'))
		// this.$http.get('/tb/lstddemandes/19515F0D-AC9C-0812-0FCE-DEE9937C7815')
		// 	.then(response => { this.rows = response.data.ResultDemande })
	},
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
